function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Select, Stack, Button, FormControl, FormLabel, FormErrorMessage, NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, Input } from '@chakra-ui/react';
import { UserLevels } from '@/types/server';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getDefaultCommand, updateDefaultCommand } from '@/actions/CommandActions';
import Drawer from '@/components/Drawer';
import { useIntl, FormattedMessage } from 'react-intl';
import useIntlMemo from '@/hooks/useIntlMemo';
import useDebouncedCallbackOnChange from '@/hooks/useDebouncedCallbackOnChange';
var MIN_COOLDOWN = 1;
var MAX_COOLDOWN = 300;
var DEFAULT_VALUES = {
    userLevel: UserLevels.EVERYONE,
    coolDown: 5
};
function useDefaultCommandFormSchema() {
    return useIntlMemo(function(intl) {
        return Yup.object().shape({
            userLevel: Yup.string().required(intl.formatMessage({
                id: "fS3inH",
                defaultMessage: [
                    {
                        type: 0,
                        value: "User level is required"
                    }
                ]
            })),
            coolDown: Yup.number().required(intl.formatMessage({
                id: "JVJy/u",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cooldown is required"
                    }
                ]
            })).min(MIN_COOLDOWN, intl.formatMessage({
                id: "DmRtwY",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cooldown must be at least 1 second long"
                    }
                ]
            })).max(MAX_COOLDOWN, intl.formatMessage({
                id: "+rzoMT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cooldown must be at most 300 seconds long"
                    }
                ]
            }))
        });
    });
}
function EditDefaultCommandDrawer(props) {
    var DefaultCommandFormSchema = useDefaultCommandFormSchema();
    var intl = useIntl();
    var onClose = props.onClose, command = props.command, isOpen = props.isOpen, channel = props.channel, rest = _object_without_properties(props, [
        "onClose",
        "command",
        "isOpen",
        "channel"
    ]);
    var formik = useFormik({
        initialValues: DEFAULT_VALUES,
        validationSchema: DefaultCommandFormSchema,
        validateOnChange: false,
        onSubmit: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(values, param) {
                var setSubmitting;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setSubmitting = param.setSubmitting;
                            if (channel == null) {
                                return [
                                    2
                                ];
                            }
                            setSubmitting(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4,
                                updateDefaultCommand(channel._id, {
                                    _name: command._name,
                                    userLevel: values.userLevel,
                                    coolDown: values.coolDown
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            onClose();
                            setSubmitting(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    useDebouncedCallbackOnChange(formik, formik.validateForm);
    React.useEffect(function() {
        if (channel == null || !isOpen) {
            return;
        }
        getDefaultCommand(channel._id, command._name);
    }, [
        command._name,
        channel,
        isOpen
    ]);
    React.useEffect(function() {
        if (!isOpen && command == null) {
            return;
        }
        formik.resetForm({
            values: {
                userLevel: command.userLevel,
                coolDown: command.coolDown
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        command,
        isOpen
    ]);
    var _command_name, _formik_values_userLevel, _channel_userLevels, _formik_values_coolDown;
    return /*#__PURE__*/ _jsx(Drawer, _object_spread_props(_object_spread({
        isOpen: isOpen,
        onClose: onClose
    }, rest), {
        footer: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    flex: 1,
                    onClick: props.onClose,
                    children: intl.formatMessage({
                        id: "47FYwb",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Cancel"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Button, {
                    flex: 1,
                    variant: "cta",
                    isDisabled: !formik.isValid || !formik.dirty,
                    isLoading: formik.isSubmitting,
                    onClick: function() {
                        return formik.submitForm();
                    },
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "Ubv/11",
                        defaultMessage: "Update Command"
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ _jsxs(Stack, {
            spacing: 6,
            height: "100%",
            children: [
                /*#__PURE__*/ _jsxs(FormControl, {
                    isDisabled: true,
                    children: [
                        /*#__PURE__*/ _jsx(FormLabel, {
                            htmlFor: "name",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "HAlOn1",
                                defaultMessage: "Name"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Input, {
                            value: (_command_name = command.name) !== null && _command_name !== void 0 ? _command_name : ''
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(FormControl, {
                    id: "userLevel",
                    isInvalid: formik.errors.userLevel != null && formik.touched.userLevel,
                    children: [
                        /*#__PURE__*/ _jsx(FormLabel, {
                            htmlFor: "userLevel",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "yoVadE",
                                defaultMessage: "Required User-Level"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Select, {
                            onBlur: formik.handleBlur,
                            value: (_formik_values_userLevel = formik.values.userLevel) !== null && _formik_values_userLevel !== void 0 ? _formik_values_userLevel : '',
                            onChange: formik.handleChange,
                            children: Object.entries((_channel_userLevels = channel === null || channel === void 0 ? void 0 : channel.userLevels) !== null && _channel_userLevels !== void 0 ? _channel_userLevels : {}).map(function(param) {
                                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                                return /*#__PURE__*/ _jsx("option", {
                                    value: key,
                                    children: value
                                }, key);
                            })
                        }),
                        /*#__PURE__*/ _jsx(FormErrorMessage, {
                            children: formik.errors.userLevel
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(FormControl, {
                    id: "coolDown",
                    isInvalid: formik.errors.coolDown != null && formik.touched.coolDown,
                    children: [
                        /*#__PURE__*/ _jsx(FormLabel, {
                            htmlFor: "coolDown",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "1PlglC",
                                defaultMessage: "Cooldown (seconds)"
                            })
                        }),
                        /*#__PURE__*/ _jsxs(NumberInput, {
                            max: MAX_COOLDOWN,
                            min: MIN_COOLDOWN,
                            value: (_formik_values_coolDown = formik.values.coolDown) !== null && _formik_values_coolDown !== void 0 ? _formik_values_coolDown : '',
                            onChange: function(_, newValue) {
                                return formik.setFieldValue('coolDown', isNaN(newValue) ? 0 : newValue);
                            },
                            children: [
                                /*#__PURE__*/ _jsx(NumberInputField, {
                                    onBlur: formik.handleBlur,
                                    placeholder: "5"
                                }),
                                /*#__PURE__*/ _jsxs(NumberInputStepper, {
                                    children: [
                                        /*#__PURE__*/ _jsx(NumberIncrementStepper, {}),
                                        /*#__PURE__*/ _jsx(NumberDecrementStepper, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(FormErrorMessage, {
                            children: formik.errors.coolDown
                        })
                    ]
                })
            ]
        })
    }));
}
export default EditDefaultCommandDrawer;
